export function preloader() {
  const preloader = $(".preloader");
  let loaded = false;
  if(preloader) {
    this.$document.ready(function () {
      loaded = true;
    });
    setTimeout(() => {
      if (loaded && preloader.length) {
        preloader.fadeOut();
      }
    }, 3000);
  }
}


// WEBPACK FOOTER //
// ./assets/js/modules/preloader.js